import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chevron Left"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chevron-left',
    templateUrl: './icon-chevron-left.component.html',
    styleUrls: ['./icon-chevron-left.component.scss'],
    standalone: false
})
export class IconChevronLeftComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
